import React from 'react';

export default function GeofenceIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '24'}
      height={props.height ?? '24'}
      {...props}
    >
      <path
        d="M10.5 22.0001C6.365 22.0001 3 20.4301 3 18.5001C3 17.1001 4.77307 15.8431 7.51807 15.2881C8.44456 16.4986 9.44016 17.6545 10.5 18.7501C11.5601 17.6549 12.5554 16.499 13.481 15.2881C16.227 15.8441 18 17.1051 18 18.5001C18 20.4301 14.636 22.0001 10.5 22.0001Z"
        stroke="#909090"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 9C16.5 12.7 10.5 18.75 10.5 18.75C10.5 18.75 4.5 12.703 4.5 9C4.5 7.4087 5.13211 5.88254 6.25732 4.75732C7.38254 3.63211 8.9087 3 10.5 3C12.0913 3 13.6175 3.63211 14.7427 4.75732C15.8679 5.88254 16.5 7.4087 16.5 9Z"
        stroke="#909090"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11.5C11.8807 11.5 13 10.3807 13 9C13 7.61929 11.8807 6.5 10.5 6.5C9.11929 6.5 8 7.61929 8 9C8 10.3807 9.11929 11.5 10.5 11.5Z"
        stroke="#909090"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 1.5C18.933 1.5 20.5 3.067 20.5 5C20.5 6.933 18.933 8.5 17 8.5C15.067 8.5 13.5 6.933 13.5 5C13.5 3.067 15.067 1.5 17 1.5Z"
        fill="#DC4405"
        stroke="white"
      />
    </svg>
  );
}
